import {ArchiveConstants} from "./const";

export const filterArchivalLogs = (logs, type) => logs.filter(log => type === undefined || log.archival_type === type);

export const getLastArchivalLogOfType = (logs, type) => filterArchivalLogs(logs, type).pop()

export const getLastDateOfArchivalType = (logs, type) => new Date(getLastArchivalLogOfType(logs, type).timestamp)

export const getLastRetrievedDate = logs => getLastDateOfArchivalType(logs, ArchiveConstants.STATUS.RETRIEVED)
